export const profileTour = {
  key: "profile",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="profile-hero"]',
      content: t("Tour_Profile_Hero"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="profile-stats"]',
      content: t("Tour_Profile_Stats"),
      placement: "bottom",
    },
    {
      target: '[data-tour="profile-actions"]',
      content: t("Tour_Profile_Actions"),
      placement: "bottom",
    },
    {
      target: '[data-tour="profile-tabs"]',
      content: t("Tour_Profile_Tabs"),
      placement: "bottom",
    },
    {
      target: '[data-tour="profile-tab-content"]',
      content: t("Tour_Profile_TabContent"),
      placement: "top",
    },
    {
      target: '[data-tour="feed-composer"]',
      content: t("Tour_Feed_Composer"),
      placement: "bottom",
    },
    {
      target: '[data-tour="feed-share"]',
      content: t("Tour_Feed_Share"),
      placement: "bottom",
    },
    {
      target: '[data-tour="feed-photo"]',
      content: t("Tour_Feed_Photo"),
      placement: "bottom",
    },
    {
      target: '[data-tour="feed-video"]',
      content: t("Tour_Feed_Video"),
      placement: "bottom",
    },
    {
      target: '[data-tour="feed-story"]',
      content: t("Tour_Feed_Story"),
      placement: "bottom",
    },
    {
      target: '[data-tour="profile-services"]',
      content: t("Tour_Profile_Services"),
      placement: "top",
    },
    {
      target: '[data-tour="profile-background"]',
      content: t("Tour_Profile_Background"),
      placement: "top",
    },
    {
      target: '[data-tour="profile-sidebar"]',
      content: t("Tour_Profile_Sidebar"),
      placement: "left",
    },
    {
      target: '[data-tour="profile-viewers"]',
      content: t("Tour_Profile_Viewers"),
      placement: "left",
    },
  ],
};
